/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Tax_BehaviorInputs */

const en__field_tax_behavior = /** @type {(inputs: _Field_Tax_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax`)
};

const de__field_tax_behavior = /** @type {(inputs: _Field_Tax_BehaviorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steuer`)
};

/**
* | output |
* | --- |
* | "Tax" |
*
* @param {_Field_Tax_BehaviorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_tax_behavior = /** @type {((inputs?: _Field_Tax_BehaviorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Tax_BehaviorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_tax_behavior(inputs)
	return de__field_tax_behavior(inputs)
});